"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWorklogAdjustEstimateEnum = exports.DeleteWorklogAdjustEstimateEnum = exports.AddWorklogAdjustEstimateEnum = exports.IssueWorklogsApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class IssueWorklogsApi extends runtime.BaseAPI {
    /**
     * Adds a worklog to an issue.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* and *Work on issues* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Add worklog
     */
    addWorklogRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling addWorklog().');
            }
            if (requestParameters['worklog'] == null) {
                throw new runtime.RequiredError('worklog', 'Required parameter "worklog" was null or undefined when calling addWorklog().');
            }
            const queryParameters = {};
            if (requestParameters['notifyUsers'] != null) {
                queryParameters['notifyUsers'] = requestParameters['notifyUsers'];
            }
            if (requestParameters['adjustEstimate'] != null) {
                queryParameters['adjustEstimate'] = requestParameters['adjustEstimate'];
            }
            if (requestParameters['newEstimate'] != null) {
                queryParameters['newEstimate'] = requestParameters['newEstimate'];
            }
            if (requestParameters['reduceBy'] != null) {
                queryParameters['reduceBy'] = requestParameters['reduceBy'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            if (requestParameters['overrideEditableFlag'] != null) {
                queryParameters['overrideEditableFlag'] = requestParameters['overrideEditableFlag'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issue/{issueIdOrKey}/worklog`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorklogToJSON)(requestParameters['worklog']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorklogFromJSON)(jsonValue));
        });
    }
    /**
     * Adds a worklog to an issue.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* and *Work on issues* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Add worklog
     */
    addWorklog(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addWorklogRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a worklog from an issue.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  *Delete all worklogs*[ project permission](https://confluence.atlassian.com/x/yodKLg) to delete any worklog or *Delete own worklogs* to delete worklogs created by the user,  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Delete worklog
     */
    deleteWorklogRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling deleteWorklog().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteWorklog().');
            }
            const queryParameters = {};
            if (requestParameters['notifyUsers'] != null) {
                queryParameters['notifyUsers'] = requestParameters['notifyUsers'];
            }
            if (requestParameters['adjustEstimate'] != null) {
                queryParameters['adjustEstimate'] = requestParameters['adjustEstimate'];
            }
            if (requestParameters['newEstimate'] != null) {
                queryParameters['newEstimate'] = requestParameters['newEstimate'];
            }
            if (requestParameters['increaseBy'] != null) {
                queryParameters['increaseBy'] = requestParameters['increaseBy'];
            }
            if (requestParameters['overrideEditableFlag'] != null) {
                queryParameters['overrideEditableFlag'] = requestParameters['overrideEditableFlag'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issue/{issueIdOrKey}/worklog/{id}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a worklog from an issue.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  *Delete all worklogs*[ project permission](https://confluence.atlassian.com/x/yodKLg) to delete any worklog or *Delete own worklogs* to delete worklogs created by the user,  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Delete worklog
     */
    deleteWorklog(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deleteWorklogRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a list of IDs and delete timestamps for worklogs deleted after a date and time.  This resource is paginated, with a limit of 1000 worklogs per page. Each page lists worklogs from oldest to youngest. If the number of items in the date range exceeds 1000, `until` indicates the timestamp of the youngest item on the page. Also, `nextPage` provides the URL for the next page of worklogs. The `lastPage` parameter is set to true on the last page of worklogs.  This resource does not return worklogs deleted during the minute preceding the request.  **[Permissions](#permissions) required:** Permission to access Jira.
     * Get IDs of deleted worklogs
     */
    getIdsOfWorklogsDeletedSinceRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['since'] != null) {
                queryParameters['since'] = requestParameters['since'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/worklog/deleted`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ChangedWorklogsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a list of IDs and delete timestamps for worklogs deleted after a date and time.  This resource is paginated, with a limit of 1000 worklogs per page. Each page lists worklogs from oldest to youngest. If the number of items in the date range exceeds 1000, `until` indicates the timestamp of the youngest item on the page. Also, `nextPage` provides the URL for the next page of worklogs. The `lastPage` parameter is set to true on the last page of worklogs.  This resource does not return worklogs deleted during the minute preceding the request.  **[Permissions](#permissions) required:** Permission to access Jira.
     * Get IDs of deleted worklogs
     */
    getIdsOfWorklogsDeletedSince(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIdsOfWorklogsDeletedSinceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a list of IDs and update timestamps for worklogs updated after a date and time.  This resource is paginated, with a limit of 1000 worklogs per page. Each page lists worklogs from oldest to youngest. If the number of items in the date range exceeds 1000, `until` indicates the timestamp of the youngest item on the page. Also, `nextPage` provides the URL for the next page of worklogs. The `lastPage` parameter is set to true on the last page of worklogs.  This resource does not return worklogs updated during the minute preceding the request.  **[Permissions](#permissions) required:** Permission to access Jira, however, worklogs are only returned where either of the following is true:   *  the worklog is set as *Viewable by All Users*.  *  the user is a member of a project role or group with permission to view the worklog.
     * Get IDs of updated worklogs
     */
    getIdsOfWorklogsModifiedSinceRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['since'] != null) {
                queryParameters['since'] = requestParameters['since'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/worklog/updated`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ChangedWorklogsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a list of IDs and update timestamps for worklogs updated after a date and time.  This resource is paginated, with a limit of 1000 worklogs per page. Each page lists worklogs from oldest to youngest. If the number of items in the date range exceeds 1000, `until` indicates the timestamp of the youngest item on the page. Also, `nextPage` provides the URL for the next page of worklogs. The `lastPage` parameter is set to true on the last page of worklogs.  This resource does not return worklogs updated during the minute preceding the request.  **[Permissions](#permissions) required:** Permission to access Jira, however, worklogs are only returned where either of the following is true:   *  the worklog is set as *Viewable by All Users*.  *  the user is a member of a project role or group with permission to view the worklog.
     * Get IDs of updated worklogs
     */
    getIdsOfWorklogsModifiedSince(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIdsOfWorklogsModifiedSinceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns worklogs for an issue, starting from the oldest worklog or from the worklog started on or after a date and time.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** Workloads are only returned where the user has:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Get issue worklogs
     */
    getIssueWorklogRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getIssueWorklog().');
            }
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['startedAfter'] != null) {
                queryParameters['startedAfter'] = requestParameters['startedAfter'];
            }
            if (requestParameters['startedBefore'] != null) {
                queryParameters['startedBefore'] = requestParameters['startedBefore'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issue/{issueIdOrKey}/worklog`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageOfWorklogsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns worklogs for an issue, starting from the oldest worklog or from the worklog started on or after a date and time.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** Workloads are only returned where the user has:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Get issue worklogs
     */
    getIssueWorklog(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIssueWorklogRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a worklog.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Get worklog
     */
    getWorklogRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getWorklog().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getWorklog().');
            }
            const queryParameters = {};
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issue/{issueIdOrKey}/worklog/{id}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorklogFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a worklog.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Get worklog
     */
    getWorklog(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWorklogRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns worklog details for a list of worklog IDs.  The returned list of worklogs is limited to 1000 items.  **[Permissions](#permissions) required:** Permission to access Jira, however, worklogs are only returned where either of the following is true:   *  the worklog is set as *Viewable by All Users*.  *  the user is a member of a project role or group with permission to view the worklog.
     * Get worklogs
     */
    getWorklogsForIdsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['worklogIdsRequestBean'] == null) {
                throw new runtime.RequiredError('worklogIdsRequestBean', 'Required parameter "worklogIdsRequestBean" was null or undefined when calling getWorklogsForIds().');
            }
            const queryParameters = {};
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/worklog/list`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorklogIdsRequestBeanToJSON)(requestParameters['worklogIdsRequestBean']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.WorklogFromJSON));
        });
    }
    /**
     * Returns worklog details for a list of worklog IDs.  The returned list of worklogs is limited to 1000 items.  **[Permissions](#permissions) required:** Permission to access Jira, however, worklogs are only returned where either of the following is true:   *  the worklog is set as *Viewable by All Users*.  *  the user is a member of a project role or group with permission to view the worklog.
     * Get worklogs
     */
    getWorklogsForIds(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWorklogsForIdsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates a worklog.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  *Edit all worklogs*[ project permission](https://confluence.atlassian.com/x/yodKLg) to update any worklog or *Edit own worklogs* to update worklogs created by the user.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Update worklog
     */
    updateWorklogRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling updateWorklog().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateWorklog().');
            }
            if (requestParameters['worklog'] == null) {
                throw new runtime.RequiredError('worklog', 'Required parameter "worklog" was null or undefined when calling updateWorklog().');
            }
            const queryParameters = {};
            if (requestParameters['notifyUsers'] != null) {
                queryParameters['notifyUsers'] = requestParameters['notifyUsers'];
            }
            if (requestParameters['adjustEstimate'] != null) {
                queryParameters['adjustEstimate'] = requestParameters['adjustEstimate'];
            }
            if (requestParameters['newEstimate'] != null) {
                queryParameters['newEstimate'] = requestParameters['newEstimate'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            if (requestParameters['overrideEditableFlag'] != null) {
                queryParameters['overrideEditableFlag'] = requestParameters['overrideEditableFlag'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/issue/{issueIdOrKey}/worklog/{id}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorklogToJSON)(requestParameters['worklog']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorklogFromJSON)(jsonValue));
        });
    }
    /**
     * Updates a worklog.  Time tracking must be enabled in Jira, otherwise this operation returns an error. For more information, see [Configuring time tracking](https://confluence.atlassian.com/x/qoXKM).  This operation can be accessed anonymously.  **[Permissions](#permissions) required:**   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.  *  *Edit all worklogs*[ project permission](https://confluence.atlassian.com/x/yodKLg) to update any worklog or *Edit own worklogs* to update worklogs created by the user.  *  If the worklog has visibility restrictions, belongs to the group or has the role visibility is restricted to.
     * Update worklog
     */
    updateWorklog(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateWorklogRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.IssueWorklogsApi = IssueWorklogsApi;
/**
 * @export
 */
exports.AddWorklogAdjustEstimateEnum = {
    New: 'new',
    Leave: 'leave',
    Manual: 'manual',
    Auto: 'auto'
};
/**
 * @export
 */
exports.DeleteWorklogAdjustEstimateEnum = {
    New: 'new',
    Leave: 'leave',
    Manual: 'manual',
    Auto: 'auto'
};
/**
 * @export
 */
exports.UpdateWorklogAdjustEstimateEnum = {
    New: 'new',
    Leave: 'leave',
    Manual: 'manual',
    Auto: 'auto'
};
//# sourceMappingURL=IssueWorklogsApi.js.map